import React from "react";
import ButtonActionComponent from '../../../../components/Button/ButtonActionComponent'

import { VaccsUpload } from "./VaccsUpload";
import GetVaccCards from "./GetVaccCards"
import { TextVaccs1 } from "./TextVaccs1";


export default function VaccsActions2() {

return(
<>      

<ButtonActionComponent

ListTitle={"Vaccination Cards"}
ListComponent={<GetVaccCards /> }
AddTitle={"Add new vaccination card"}
AddComponent={<VaccsUpload />}
InfoTitle={"Immunisation"}
InfoComponent={ <TextVaccs1 />}

/>

</>
)}